import React from 'react';

interface CircularProgressBarProps {
  size?: number;
  strokeWidth?: number;
  progress: number;
}

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({
  size = 100,
  strokeWidth = 10,
  progress,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div
      className='relative flex items-center justify-center'
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className='transform -rotate-90'>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke='#e5e7eb'
          strokeWidth={strokeWidth}
          fill='transparent'
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke='#033EB5'
          strokeWidth={strokeWidth}
          fill='transparent'
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap='round'
          className='transition-all duration-300'
        />
      </svg>
      <div className='absolute text-blue-600 text-xs font-semibold'>
        {progress}%
      </div>
    </div>
  );
};

export default CircularProgressBar;
